import { ApolloError, useQuery } from '@apollo/client';

import {
  GET_COMPANY_OFFICER_PAYROLL_QRES,
  GetCompanyOfficerPayrollQresQuery,
  GetCompanyOfficerPayrollQresQueryVariables,
  PayrollQreFragment,
} from '@neo.tax/shared';

export const useGetCompanyOfficerPayrollQres = (
  fiscalYearId: string,
): {
  companyOfficerPayrollQres: PayrollQreFragment[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, error, loading } = useQuery<
    GetCompanyOfficerPayrollQresQuery,
    GetCompanyOfficerPayrollQresQueryVariables
  >(GET_COMPANY_OFFICER_PAYROLL_QRES, {
    variables: {
      fiscalYearId,
    },
    context: {
      errorToast: {
        title: 'Error fetching company officers',
        description: 'Try refreshing the page.',
      },
    },
  });

  return {
    companyOfficerPayrollQres: data?.getCompanyOfficerPayrollQres ?? [],
    loading,
    error,
  };
};
